"use strict";

exports.__esModule = true;
exports.default = void 0;

var _embed = require("./embed");

var _plugins = require("../../utils/plugins");

var components = {
  BEmbed: _embed.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/embed/index.js
// module id = gY5a
// module chunks = 14